<template>
  <div v-if="aditivoCarregado" id="wrapper">
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Detalhes do Aditivo de Contrato</span>
          <btn-voltar />
        </h6>
      </template>
      <b-tabs card>
        <b-tab title="Dados gerais">
          <b-row class="m-2">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>N°/Ano do Aditivo</b></span>
              <br />
              <span class="pos-left">{{ `${aditivo.NrAditivoContrato}/${aditivo.NrAnoAditivoContrato}` }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Tipo do Termo Aditivo</b></span>
              <br />
              <span class="pos-left">{{ aditivo.IdTipoTermoAditivoNavigation.DeTipoTermoAditivo }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Natureza do Ajuste</b></span>
              <br />
              <span class="pos-left">{{ aditivo.IdNaturezaAjusteNavigation.DeNaturezaAjuste }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Contrato</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DescricaoContrato }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Justificativa</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DeJustificativaAditivo }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Arquivo Texto do Termo Aditivo do Contrato</b></span>
              <br />              
                <div class="d-flex">
                  <btn-download :fazerDownload="baixarAnexo" :texto="''" />
                  <span class="pos-left ml-2">Baixar arquivo</span>
                </div>
            </b-col>
            <br/>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Início de Vigência</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DtInicioVigenciaAditivo ? formatData(aditivo.DtInicioVigenciaAditivo) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Fim de Vigência</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DtFimVigenciaAditivo ? formatData(aditivo.DtFimVigenciaAditivo) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Valor do Aditamento/Supressão</b></span>
              <br />
              <span class="pos-left">{{ aditivo.VlAditivoContrato ? aditivo.VlAditivoContrato : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Assinatura</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DtAssinaturaAditivo ? formatData(aditivo.DtAssinaturaAditivo) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Publicação</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DtPublicacaoAditivo ? formatData(aditivo.DtPublicacaoAditivo) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Anulação</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DtAnulacaoAditivo ? formatData(aditivo.DtAnulacaoAditivo) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Motivo da Anulação</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DeMotivoAnulacaoAditivo ? aditivo.DeMotivoAnulacaoAditivo : '-' }}</span>
            </b-col>
          </b-row>
          <div v-if="aditivo.DeJustificativaAlteracaoSubjetiva" id="infoNovoContratado">
            <span><b>Informações do novo contratado</b></span>
            <b-row class="m-2">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>CPF/CNPJ</b></span>
              <br />
              <span class="pos-left">{{ aditivo.CdCpfCnpjParticipante }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Nome/Razão Social</b></span>
              <br />
              <span class="pos-left">{{ aditivo.NmParticipante }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Justificativa da Alteração Subjetiva</b></span>
              <br />
              <span class="pos-left">{{ aditivo.DeJustificativaAlteracaoSubjetiva }}</span>
            </b-col>
          </b-row>
          </div>
        </b-tab>
        <b-tab title="Histórico de alterações">
          <b-table :busy="tableBusy" :fields="fieldsLogs" hover no-border-collapse :items="itemsLogs" sort-by="" :sort-desc="true"
          striped stacked="sm" per-page="10" :current-page="currentPageLogs" show-empty small>
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPageLogs" :total-rows="itemsLogs.length" per-page="10" aria-controls="my-table" />
        </b-tab>
      </b-tabs>  
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'

import { store } from "@/store"
import { UtilsTS } from '@/utilsts'

import aditivosContratoService from '@/services/licitacoes/aditivosContratoService'

import { AditivoContrato } from '@/types/licitacoes/aditivo-contrato/aditivo-contrato'
import { LogEvento } from '@/types/licitacoes/log-evento'
import { fieldsLogsEventos } from '@/types/licitacoes/fields-logs-eventos'
import { TableField } from '@/types/table-field';

const CompProps = Vue.extend({
  name: 'DetalhesAditivoContrato',
  components: { BtnVoltar, BtnDownload },
  props: {
    idAditivo: {
      type: String,
      required: true
    }
  }
})

@Component
export default class DetalhesAditivoContrato extends mixins(UtilsTS, CompProps) {
  tableBusy = false
  aditivo: AditivoContrato = new AditivoContrato()
  itemsLogs: LogEvento[] = []
  fieldsLogs: TableField[] = fieldsLogsEventos
  currentPageLogs = 1
  aditivoCarregado = false

  async created() {
    try {
      store.blockScreen = true
      this.tableBusy = true
      const aditivoApi = await aditivosContratoService.buscarAditivo(this.idAditivo)
      if (aditivoApi && aditivoApi.status === 200) {
        this.aditivo = Object.assign(this.aditivo, aditivoApi.data)
        this.aditivo.tratarDadosDaAPI()
        const responseLogs = await aditivosContratoService.listarLogs(this.aditivo.IdAditivoContrato);
        if (responseLogs && responseLogs.status === 200) {
          this.itemsLogs = responseLogs.data.map((l: any) => {
          const retorno = Object.assign(new LogEvento(), l)
          if(retorno.TipoLog == 'I')
            retorno.TipoLog = 'Inserção'
          if(retorno.TipoLog == 'U')
            retorno.TipoLog = 'Alteração'
          retorno.DtLog = this.formatDataComHora(retorno.DtLog)
          return retorno
        })
      } else {
        throw new Error(responseLogs.data && responseLogs.data.msg ? responseLogs.data.msg : 'Ocorreu um erro ao realizar a consulta.')
      }
        this.aditivoCarregado = true
      } else {
        this.$router.push("/modulo-licitacoes/aditivos-contratos");
        this.$toast.error(aditivoApi.data.msg || "Erro ao carregar aditivo");
      }
    } catch(e: any) {
      console.error('Erro ao montar detalhes de aditivo', e)
      this.$router.push("/modulo-licitacoes/aditivos-contratos");
      this.$toast.error(e.message || "Erro ao carregar aditivo");
    } finally {
      this.tableBusy = false
      store.blockScreen = false
    }
  }

  async baixarAnexo() {
    const arquivo = this.aditivo.ArquivoAditivoContrato[0]
    const response = await aditivosContratoService.baixarAnexo(arquivo?.IdArquivo)
    this.download(arquivo?.DeNomeArqTextoAditivo, response.data)
  }
};
</script>

<style>
</style>